
import Vue from 'vue';
import moment from 'moment';
import numeral from 'numeral';


Vue.filter('datetime',  (value) => {
  return value ? moment(value).format('DD/MM/YYYY HH:mm') : value;
});

Vue.filter('date',  (value) => {
  return value ? moment(value).format('DD/MM/YYYY') : value;
});

Vue.filter('time', (value) => {
  return value ? moment(value).format('HH:mm') : value;
});

Vue.filter('money',  (value, fraction) => {
  const digits = fraction || 2;
  return value ? value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', minimumFractionDigits: digits }) : 'R$0,000';
});

Vue.filter('number', (value) => {
  let num =  numeral(value).format('0,0'); // displaying other groupings/separators is possible, look at the docs
  return num.replace(/,/gm, '.');
});

Vue.filter('phone', (value) => {
  if (value) {
    const newValue = value.toString();
    if (newValue.length === 11) {
      return newValue.replace(/(\d\d)(\d\d\d\d\d)(\d\d\d\d)/, '($1)$2-$3');
    } else if (newValue.length === 10) {
      return newValue.replace(/(\d\d)(\d\d\d\d)(\d\d\d\d)/, '($1)$2-$3');
    }
  } else {
    return value;
  }
});

Vue.filter('cpfcnpj', (value) => {
  let newValue = value;
  if (newValue) {
    if (newValue.length === 11) {
      newValue = newValue.toString().replace(/\D/g, '').replace(/^(\d{3})(\d{3})?(\d{3})?(\d{2})?/, '$1 $2 $3-$4');
    } else {
      newValue = newValue.toString().replace(/\D/g, '').replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/, '$1 $2 $3/$4-$5');
    }
  }
  return newValue;
});
